/**
 * "Zum Home-Bildschirm hinzufuegen" - der Weg zum Vollbild auf dem iPhone
 * (Produktentscheidung vom 15.10.2026).
 *
 * Robin: "Lege diese Info direkt ueber alles drueber, bevor man ueberhaupt
 * im Menue spielen kann. Dieser Hinweis darf natuerlich nur kommen, wenn man
 * mit Safari das Spiel oeffnet und auch nur am Handy."
 *
 * WANN er kommt, entscheidet zeigeStartbildschirmHinweis - eine eigene
 * Regel, die sich ohne Bild pruefen laesst. Kurz: nur am Finger-Geraet, nur
 * wo Vollbild wirklich nicht geht, nicht wenn wir schon vom Home-Bildschirm
 * laufen, und nicht mehr, wenn er einmal weggetippt wurde.
 *
 * Derselbe Text steht dauerhaft in den Einstellungen (HomescreenHilfe) -
 * ausdruecklich auch fuer Geraete, die den Hinweis nie zu sehen bekommen.
 */

import { useState } from 'react';
import { t } from '../i18n/index.js';
import { isTouchDevice, laeuftAlsApp, vollbildMoeglich } from './fullscreen.js';
import {
  hinweisSchonGelesen,
  merkeHinweisGelesen,
  zeigeStartbildschirmHinweis,
} from './startbildschirm.js';

/** Die drei Schritte - an beiden Orten dieselben. */
function Schritte() {
  return (
    <ol className="dl-homescreen__schritte">
      <li>{t.homescreen.step1}</li>
      <li>{t.homescreen.step2}</li>
      <li>{t.homescreen.step3}</li>
    </ol>
  );
}

export function StartbildschirmHinweis() {
  /*
   * Einmal beim Aufbau gefragt und danach nicht mehr.
   *
   * Alle drei Antworten koennen sich im laufenden Betrieb nicht aendern: Ein
   * Geraet bekommt keinen Finger dazu, Safari lernt kein Vollbild, und vom
   * Browser in die Home-Bildschirm-App wechselt man nur durch Neustart.
   */
  const [offen, setOffen] = useState(() =>
    zeigeStartbildschirmHinweis({
      tippflaeche: isTouchDevice(),
      vollbildMoeglich: vollbildMoeglich(),
      schonAlsApp: laeuftAlsApp(),
      schonGelesen: hinweisSchonGelesen(),
    }),
  );

  if (!offen) return null;

  return (
    <div className="dl-homescreen" role="dialog" aria-modal="true">
      <div className="dl-homescreen__panel">
        <h2 className="dl-homescreen__title">{t.homescreen.title}</h2>
        <p className="dl-homescreen__why">{t.homescreen.why}</p>
        <Schritte />
        <button
          type="button"
          className="dl-button dl-homescreen__weiter"
          onClick={() => {
            merkeHinweisGelesen();
            setOffen(false);
          }}
        >
          {t.homescreen.dismiss}
        </button>
      </div>
    </div>
  );
}

/**
 * Derselbe Weg, dauerhaft in den Einstellungen (Robin, 15.10.2026: "damit
 * auch andere Browser bzw. Handys das trotzdem machen koennen").
 *
 * Steht dort auf JEDEM Finger-Geraet - auch auf einem, das Vollbild kann.
 * Vom Home-Bildschirm gestartet ist es trotzdem schoener: kein Antippen
 * noetig, eigenes Symbol, und es startet sofort im Querformat.
 *
 * Nur wenn wir schon so laufen, waere es ein Rat ins Leere.
 */
export function HomescreenHilfe() {
  if (!isTouchDevice() || laeuftAlsApp()) return null;

  return (
    <div className="dl-homescreen__panel dl-homescreen__panel--inline">
      <div className="dl-menu__abschnittTitel">{t.homescreen.settings}</div>
      <p className="dl-homescreen__why">{t.homescreen.settingsHint}</p>
      <Schritte />
    </div>
  );
}
